import PowerBiGraph from './PowerBiGraph';

export default PowerBiGraph;
